<template>
  <el-dialog
    :title="title"
    :visible.sync="disableDialog"
    width="600px"
    @close="onClose"
  >
    <el-form :model="queryParams">
      <el-row :gutter="20">
        <el-col :span="24">
          <tags-input
            :disabled="disabled"
            v-model="textarea"
            :placeholder="placeholder"
            ref="tagsInputRefs"
          />
        </el-col>
      </el-row>
      <el-row
        :gutter="20"
        style="margin-top:10px;"
      >
        <slot name="operating">
          <el-col :span="4">
            <el-button
              type="text"
              @click="downLoadFile"
              style="padding-left:30px;"
            >下载模板
            </el-button>
          </el-col>
          <el-col :span="20">
            <el-upload
              class="upload-demo"
              action="api/purchaseContractDeliverBase/queryLeadSerialCode"
              :headers="myHeaders"
              :on-success="onSuccess"
              :show-file-list="false"
            >
              <el-button type="text">导入序列号</el-button>
            </el-upload>
          </el-col>
        </slot>
      </el-row>
    </el-form>
    <div style="display: flex;justify-content: flex-end">
      <slot name="footer">
        <el-button
          type="primary"
          @click="onsubmit"
        >提 交
        </el-button>
        <el-button @click="onClose">取 消</el-button>
      </slot>
    </div>
  </el-dialog>
</template>
<script>
import { querySystemAttachmentAddressVo } from '@/api/purchase/purchaseManage'

import { duplicates, uploadDownExcel } from '@/util/tool'
import { getToken } from '@/util/auth' // get token from cookie
import TagsInput from '@/components/inputTags/index.vue'

export default {
  components: {
    TagsInput
  },
  data () {
    return {
      myHeaders: {},
      fileList: [],
      disableDialog: false,
      textarea: [], // 序列号内容
      queryParams: {},
      index: '',
      placeholder: '输入产品序列号，多个序列号可以回车或用英文分号（;）隔开'
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '录入产品序列号'
    }
  },
  watch: {
    disabled(value) {
      if (value) {
        this.placeholder = ''
      } else {
        this.placeholder = '输入产品序列号，多个序列号可以回车或用英文分号（;）隔开'
      }
    }
  },
  methods: {
    onClose () {
      this.disableDialog = false
      this.$refs.tagsInputRefs.current = null
    },
    // 调入序列号内容初始化方法
    onInitial (val, index, status, dis) {
      this.myHeaders = {
        Authorization: ` Bearer ${getToken()}`
      }
      this.disableDialog = true
      this.textarea = []
      this.index = index
      if (status === 1) {
        // 编辑
        this.textarea = val.serialCode.split(';')
      }
      if (dis) {
        this.placeholder = ''
      }
    },
    downLoadFile () {
      querySystemAttachmentAddressVo('5fe97edacb608efc411daeb9').then((res) => {
        if (res.data.code === 200) {
          uploadDownExcel(
            this.$store.state.https + res.data.obj.filePath,
            '通用导入序列号模板'
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 提交
    onsubmit () {
      this.disableDialog = false
      if (this.textarea === []) {
        this.$message.error('请输入至少一个序列号！')
      } else {
        this.$emit('inProuctSerial', this.textarea.join(';'), this.index)
      }
    },
    onSuccess (response, file, fileList) {
      const data = response.obj.split(';')
      const textareaList = this.textarea.concat(data)
      this.textarea = duplicates(textareaList)
    }
  }
}
</script>
